import { AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { BaseComponentOnDestroy } from '../../epics/base-component-on-destroy';
import { EntityVersion, PhxConstants } from '../../model';
import { PhxSideBarService } from '../../services/phx-side-bar.service';
import { takeUntil } from 'rxjs/operators';
import { VersionComparisonToggleService } from '../../services/version-comparison-toggle.service';

@Component({
  selector: 'app-phx-panel-version',
  templateUrl: './phx-panel-version.component.html',
  styleUrls: ['./phx-panel-version.component.less'],
  changeDetection: ChangeDetectionStrategy.Default
})

export class PhxPanelVersionComponent extends BaseComponentOnDestroy implements OnChanges, OnInit, AfterViewInit {

  entityType: string;
  statusGroup: string;

  @Input() multiple: boolean;
  currentVersion: number;
  entityVersions: EntityVersion[];

  comparisonSourceVersionNumber$ = this.versionComparisonToggleService.versionComparisonSourceNumber$;

  phxConstants = PhxConstants;

  groupedVersions: Array<{
    entityId: number,
    isActive?: boolean,
    versions: EntityVersion[];
  }> = [];

  sortedVersions: EntityVersion[];

  constructor(
    private cdr: ChangeDetectorRef,
    private phxSidebarService: PhxSideBarService,
    private versionComparisonToggleService: VersionComparisonToggleService,
  ) {
    super();
  }

  ngOnChanges(changes: SimpleChanges) {
    this.versionChanges(changes.entityVersions, changes.currentVersion);
  }

  private versionChanges(entityVersions: any, currentVersion: any) {
    if (entityVersions || currentVersion) {
      if (this.multiple) {
        const versions = Array.isArray(this.entityVersions) ? this.entityVersions.reduce(
          (result, item: EntityVersion) => ({
            ...result,
            [item.Id]: [
              ...(result[item.Id] || []),
              item
            ]
          }),
          {}
        ) : {};

        this.groupedVersions = Object.keys(versions).map(key => ({
          entityId: parseInt(key, 10),
          isActive: (versions[key] as EntityVersion[]).some(item => item.VersionNumber === this.currentVersion),
          versions: [...versions[key] as EntityVersion[]].sort((a, b) => b.VersionNumber - a.VersionNumber)
        })).sort((a, b) => b.entityId - a.entityId);

      } else {
        this.sortedVersions = Array.isArray(this.entityVersions) ? [...this.entityVersions].sort((a, b) => b.VersionNumber - a.VersionNumber) : [];
      }
    }
  }

  ngOnInit() {
    this.subscribeVersionVariables();
  }

  ngAfterViewInit() {
    this.subscribeVersionVariables();
  }

  private subscribeVersionVariables() {
    this.phxSidebarService.entityTypeChange$().pipe(takeUntil(this.isDestroyed$)).subscribe(entityType => this.entityType = entityType);
    this.phxSidebarService.getEntityVersions$().subscribe(entityVersions => {
      this.entityVersions = entityVersions;
      this.versionChanges(this.entityVersions, this.currentVersion);
      this.cdr.detectChanges();
    }
    );
    this.phxSidebarService.getCurrentVersion$().pipe(takeUntil(this.isDestroyed$)).subscribe(currentVersion => {
      this.currentVersion = currentVersion;
      this.versionChanges(this.entityVersions, this.currentVersion);
      this.cdr.detectChanges();
    });
    this.phxSidebarService.getStatusGroup$().pipe(takeUntil(this.isDestroyed$)).subscribe(statusGroup => this.statusGroup = statusGroup);
    this.phxSidebarService.getVersionsAreMultiple$().pipe(takeUntil(this.isDestroyed$)).subscribe(areMultiple => this.multiple = areMultiple);
  }

  selectVersion(version: EntityVersion) {
    window.scroll(0, 0);
    if (this.currentVersion !== version.VersionNumber) {
      this.phxSidebarService.updateCurrentVersion$(version.VersionNumber);
      this.phxSidebarService.selectedVersion.emit(version);
    }
  }
}
